import React, {Component} from 'react';
import {connect} from 'react-redux';
import Quotes from "../../components/Quotes/quotes";
import {
    changeQuotesListPage,
    changeQuotesState,
    clearQuotesFilters,
    getQuotes, getQuotesSuccess,
    getQuotesSuggestions,
    quotesListPageShift
} from "../../actions/quotes";
import {getBrokerFirmsPostcodes,requestBrokerFirmsFiltered} from "../../actions/brokerFirms";
import {getQuoteStatuses} from "../../actions/quote";
import _ from 'lodash';

const getSuggestionValue = suggestion => suggestion.aragReference;

const renderSuggestion = suggestion => (
    <div>
        {`${suggestion.aragReference} | ${suggestion.clientName} | ${suggestion.policyStatus}`}
    </div>
);

class QuotesHOC extends Component{
    constructor(props) {
        super(props);

    }

    componentDidMount(){
        this.props.getQuoteStatuses();
        this.props.getBrokerFirmsPostcodes();
        const parameters = this._getParameters(this.props,null);
        this.props.getQuotes(parameters);
    }

    componentDidUpdate(prevProps, prevState){
        clearTimeout(this.askServer);
        if (
            (this.props.viewAmount !== prevProps.viewAmount) ||
            (this.props.page !== prevProps.page) ||
            (this.props.suggestionFieldValue !== prevProps.suggestionFieldValue) ||
            (this.props.filterPressed !== prevProps.filterPressed)
        ) {
            let parameters = this._getParameters(this.props, null);
            if (this.props.suggestionFieldValue !== prevProps.suggestionFieldValue && this.props.suggestionFieldValue !== '') {
                parameters.offset = 0;
                parameters.limit = 5;
                this.askServer = setTimeout(() => {
                    this.props.getQuotesSuggestions(parameters)
                }, 150);
            } else {
                this.props.getQuotes(parameters);
            }
        }

        if(this.props.brokerFilterSearchValue !== prevProps.brokerFilterSearchValue
            && this.props.brokerFilterSearchValue.length >= 3)
        {
            this.askServer = setTimeout(() => {
                this.props.requestBrokerFirmsFiltered( {
                    search:  this.props.brokerFilterSearchValue,
                })
            }, 500);
        }

    }

  
    _getParameters = (props, searchParameter) => {
        let calcOffset =props.viewAmount*(props.page -1);
        const statuses = this.props.selectedStatuses;
        const brokerFirms = this.props.selectedBrokerFirms;
        return {
            limit: props.viewAmount,
            offset: calcOffset > 0 ? calcOffset : 0,
            search: props.suggestionFieldValue,
            selectedQuoteStatuses: statuses.length > 0 && props.filterPressed ? statuses : null,
            selectedBrokerFirms : brokerFirms.length > 0 && props.filterPressed ? brokerFirms : null,
            postcodes: this.props.selectedPostcodes.length > 0 && props.filterPressed ? this.props.selectedPostcodes : null,
        }

    };

    onSuggestionChange = (event, { newValue }) => {
        this.props.changeQuotesState({
            key: 'suggestionFieldValue',
            value: newValue?newValue.toString():''
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        this.props.changeQuotesState({
            key: 'suggestions',
            value: this.getSuggestions()
        });
    };

    getSuggestions = value => {
        return this.props.suggestions
    };

    onSuggestionsClearRequested = () => {
        this.props.changeQuotesState({
            key: 'suggestions',
            value: []
        });
    };

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        this.props.changeQuotesState({
            key: 'suggestions',
            value: []
        });
        const parameters = this._getParameters(this.props,null);
        this.props.getQuotes(parameters);
    };

    submitListFilters = (evt) => {
        evt.preventDefault();
        // const parameters = this._getParameters(this.props,null);
        // this.props.getQuotes(parameters);
    };

    _handleAutoSuggestIconClick = () => {
        const parameters = this._getParameters(this.props,null);
        this.props.getQuotes(parameters);
    };

    handleBrokerPostcodeFilterChange = (values) => {
        this.props.changeQuotesState({ key: 'selectedPostcodes', value: values });
    };

    handleStatusFilterChange = (values) => {
        this.props.changeQuotesState({ key: 'selectedQuoteStatuses', value: values });
    };

    handleFilterClick = () => {
        this.props.changeQuotesState({ key: 'wasFilterButtonPressed', value: true });

        let parameters = this._getParameters(this.props, null)
        this.props.getQuotes(parameters);
    };

    render(){
        const autoSuggestInputProps = {
            value: this.props.suggestionFieldValue,
            onChange: this.onSuggestionChange,
            style:{height:'36px'}
        };
        const statusOptions = this.props.quoteStatuses.map(item => {
            return { key: item.name, label: item.name, value: item.machineName }
        });
    
    
        const brokerPostcodeOptions = this.props.brokerPostcodes.map(item => {
            return { key: item, label: item, value: item }
        });
        return (
            <Quotes
                {...this.props}
                onSuggestionSelected={this.onSuggestionSelected}
                renderSuggestion={renderSuggestion}
                getSuggestionValue={getSuggestionValue}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                autoSuggestInputProps={autoSuggestInputProps}
                _handleAutoSuggestIconClick={this._handleAutoSuggestIconClick}
                submitListFilters={this.submitListFilters}
                postcodeOptions={brokerPostcodeOptions}
                handleBrokerPostcodeFilterChange={this.handleBrokerPostcodeFilterChange}
                handleFilterClick={this.handleFilterClick}
                quoteStatusesOptions={statusOptions}
                handleStatusFilterChange={this.handleStatusFilterChange}
                handleClearFiltersClick={this.props.clearQuotesFilters}
                
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        quotes: state.quotes.quotes,
        page: state.quotes.page,
        totalPaginationBoxes: state.quotes.totalPaginationBoxes,
        viewAmount: state.quotes.viewAmount,
        totalRecords: state.quotes.totalRecords,
        quoteStatuses: state.quote.quoteStatuses,
        suggestions: state.quotes.suggestions,
        suggestionFieldValue: state.quotes.suggestionFieldValue,
        brokerFilterSearchValue: state.quotes.brokerFilterSearchValue,
        selectedBrokerFirms: state.quotes.selectedBrokerFirms,
        fetchingQuotes: state.quotes.fetching,
        selectedPostcodes: state.quotes.selectedPostcodes,
        selectedStatuses: state.quotes.selectedQuoteStatuses,
        filterPressed: state.quotes.wasFilterButtonPressed,
        brokerPostcodes: state.brokerFirms.brokerPostcodes,
        fetchingBrokers:state.brokerFirms.fetching,
        brokerFirmsFiltered: state.brokerFirms.brokerFirmsFiltered
        
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getQuotes: (payload) => {
            dispatch(getQuotes(payload))
        },
        quotesListPageShift: (payload) => {
            dispatch(quotesListPageShift(payload))
        },
        changeQuotesListPage: (payload) => {
            dispatch(changeQuotesListPage(payload))
        },
        changeQuotesState: (payload) => {
            dispatch(changeQuotesState(payload))
        },
        getQuoteStatuses: (payload) => {
            dispatch(getQuoteStatuses(payload))
        },
        getQuotesSuggestions: (payload) => {
            dispatch(getQuotesSuggestions(payload))
        },
        getQuotesSuccess: (payload) => {
            dispatch(getQuotesSuccess(payload))
        },
        clearQuotesFilters: (payload) => {
            dispatch(clearQuotesFilters(payload))
        },
        getBrokerFirmsPostcodes: (payload) => {
            dispatch(getBrokerFirmsPostcodes(payload))
        },  
        requestBrokerFirmsFiltered: (payload) => {
            dispatch(requestBrokerFirmsFiltered(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(QuotesHOC)